module.exports = __webpack_public_path__ + "img/moonlitHero.30a638d3.png";